export const defaultConfirmationPaneButtonGroupStyles = {
  display: "flex",
  width: "auto",
  height: "auto",
  boxSizing: "border-box",
  flexFlow: "row",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  marginBottom: "10px"
};